export default __webpack_public_path__ + "static/media/valvoline.f2d373f3.png";